module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "project-name"
  }, [_vm._v("mavonEditor")]), _vm._v(" "), _c('h3', {
    staticClass: "project-tagline"
  }, [_vm._v(_vm._s())]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor/archive/refs/heads/master.zip"
    }
  }, [_vm._v("Download .zip")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor/archive/refs/heads/master.tar.gz"
    }
  }, [_vm._v("Download .tar.gz")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('mavon-editor', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "codeStyle": _vm.codeStyle,
      "xssOptions": _vm.xssOptions
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-code-style"
  }, [_c('span', [_vm._v("code style:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeStyle),
      expression: "codeStyle"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.codeStyle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.styles), function(val, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57f20124", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f20124","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dev/editor.vue
// module id = 216
// module chunks = 0